export const INITIAL_STATE = {
  notifications: [],
};
